export default "__VITE_ASSET__1e596092__"